import { render } from "./InCallDisplay.vue?vue&type=template&id=1bd0a4cf&scoped=true"
import script from "./InCallDisplay.vue?vue&type=script&lang=js"
export * from "./InCallDisplay.vue?vue&type=script&lang=js"

import "./InCallDisplay.vue?vue&type=style&index=0&id=1bd0a4cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd0a4cf"]])

export default __exports__